export interface Message {
  id: string;
  msgId: string;
  type: MessageType;
  data: MessageData;
  isBot: boolean;
  conversationId: string;
  epoch: number;
  createdAt: string;
  updatedAt: string;
}

export interface MessageData {
  // body?:
  //   | Text
  //   | Location
  //   | OutLocation
  //   | Interactive
  //   | OutInteractive
  //   | Image
  //   | Video
  //   | Audio
  //   | ContactShared[]
  //   | Sticker
  //   | Document
  //   | OutDocument;
  filename?: string;
  link?: string;
  action?: Action;
  body?: string | DataBody;
  nfm_reply?: NfmReply;
  selected_product?: {
    name: string;
    price?: string;
    image?: string | null;
  };
  selected_products?: Array<{
    name: string;
    price?: string;
    image?: string | null;
  }>;
  selected_payment?: {
    id?: string;
    name: string;
  };
  button_reply?: ButtonReply;
  list_reply?: ListReply;
  header?: Header;
  type?: DataType; //button, flow, nfm_reply, button_reply,etc
  latitude?: number;
  longitude?: number;
  id?: string;
  mime_type?: string;
  caption?: string;
}

export interface DataBody {
  text?: string;
}

export function getMessageBodyText(
  body: string | DataBody | undefined
): string | undefined {
  return typeof body === 'string' ? body : body?.text;
}

export interface Action {
  buttons?: {
    type: string;
    reply: {
      id: string;
      title: string;
    };
  }[];
  button?: string;
  sections?: Section[];
  name?: 'flow' | 'send_location';
  parameters?: Parameters;
}

export enum DataType {
  BUTTON = 'button',
  FLOW = 'flow',
  NFM_REPLY = 'nfm_reply',
  BUTTON_REPLY = 'button_reply',
  LIST = 'list',
  LIST_REPLY = 'list_reply',
  LOCATION_REQUEST_MESSAGE = 'location_request_message',
}

export enum MessageType {
  TEXT = 'text',
  INTERACTIVE = 'interactive',
  LOCATION = 'location',
  DOCUMENT = 'document',
  STICKER = 'sticker',
  CONTACT = 'contact',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
}

// export interface Context {
//   from: string | undefined;
//   id: string | undefined;
//   forwarded: boolean | undefined;
// }

export interface Location {
  latitude: string;
  longitude: string;
  address?: string | undefined;
  name?: string | undefined;
  url?: string | undefined;
}

export interface Image {
  id: string;
  mime_type: string;
  sha256: string;
}

export interface Video {
  id: string;
  mime_type: string;
  sha256: string;
}

export interface Audio {
  id: string;
  mime_type: string;
  sha256: string;
  voice: boolean;
}

export interface Sticker {
  id: string;
  mime_type: string;
  sha256: string;
  animated: boolean;
}

export interface Document {
  id: string;
  mime_type: string;
  sha256: string;
  filename: string;
}

export interface ContactShared {
  name: { first_name: string; formatted_name: string };
  phones: { phone: string; type: string };
}

export interface Interactive {
  type: string;
  button_reply?: ButtonReply;
  nfm_reply?: NfmReply;
  list_reply?: ListReply;
}

export interface ButtonReply {
  id: string;
  title: string;
}

export interface NfmReply {
  response_json: string;
  body: string;
  name: string;
}

export interface ListReply {
  id: string;
  title: string;
}

export interface OutInteractive {
  type: string;
  header?: Header;
  body: Body;
  footer?: Footer;
  action: ActionButton | ActionFlow | ActionList;
}

export interface Header {
  type: string;
  text?: string;
  image?: {
    link: string;
  };
}

export interface Footer {
  text: string;
}

export interface ActionButton {
  buttons: {
    type: string;
    reply: {
      id: string;
      title: string;
    };
  }[];
}

export interface ActionFlow {
  name: 'flow';
  parameters: Parameters;
}

export interface Parameters {
  flow_message_version: string;
  flow_action: string;
  flow_token: string;
  flow_id: string;
  flow_cta: string;
  flow_action_payload?: FlowActionPayload;
  mode?: string;
}

export interface FlowActionPayload {
  screen: string;
}

export interface Section {
  title: string;
  rows: Row[];
}

export interface Row {
  id: string;
  title: string;
  description?: string;
}

export interface ActionList {
  button: string;
  sections: Section[];
}

export interface OutLocation {
  longitude: number;
  latitude: number;
  name: string;
  address: string;
}

export interface OutDocumentWithId {
  id: string;
  link?: string;
  filename: string;
}

export interface OutDocumentWithLink {
  id?: string;
  link: string;
  filename: string;
}

export type OutDocument = OutDocumentWithId | OutDocumentWithLink;
